import Observable from './Observable'

const loadingObservable = new Observable()

export default loadingObservable
